import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpToggleSwitchComponent } from './fcp-toggle-switch.component';

const components = [FcpToggleSwitchComponent];

@NgModule({
    declarations: components,
    imports: [CommonModule],
    exports: components
})
export class FcpToggleSwitchModule {}
